import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useUserStore } from 'src/hooks/stores';
import { useAuthModal } from 'src/modules/auth-modal-store';
import { Sections } from 'src/legacy/Components/auth/_constants';
import { shouldShowGeneralOtpModal } from '../utils/signupSourceHelpers';
import { signoutOtpWebUser, isReloadNavigation, hasOtpInteraction } from '../utils/otpHelpers';

/**
 * Hook para verificar e corrigir estado de OTP após reload da página
 * 
 * IMPORTANTE: Este hook só executa quando é realmente um RELOAD (F5), não ao abrir nova aba.
 * 
 * Quando o usuário tem OTP pendente e dá F5 fora do checkout:
 * - Se não tem token/accessToken, limpa o storage
 * - Se tem token/accessToken, abre o modal de OTP automaticamente
 * 
 * IMPORTANTE: Se houver parâmetros OTP na URL (?otp=...&email=...), não abre
 * o modal para evitar condição de corrida com a validação via link.
 * 
 * Se o token estiver inválido, o próprio fluxo de OTP (useAuthOtp) vai tratar
 * quando tentar enviar o código.
 */
export const useOtpReloadCheck = () => {
	const { userStatus, signupSource, token, accessToken } = useUserStore();
	const { setSection, onOpenWithcloseOnOverlayClick } = useAuthModal();
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const hasCheckedRef = useRef(false);

	useEffect(() => {
		if (hasCheckedRef.current) return;
		hasCheckedRef.current = true;

		if (!isReloadNavigation()) {
			return;
		}

		if (!hasOtpInteraction()) {
			return;
		}

		const otpFromUrl = searchParams.get('otp');
		const emailFromUrl = searchParams.get('email');
		const hasOtpInUrl = !!(otpFromUrl && emailFromUrl);
		
		if (hasOtpInUrl) {
			return;
		}

		const isCheckoutRoute = location.pathname.includes('/checkout');
		const shouldShowModal = shouldShowGeneralOtpModal(userStatus, signupSource, isCheckoutRoute);

		if (!shouldShowModal) return;
		if (!token || !accessToken) {
			signoutOtpWebUser();
			return;
		}
		setSection(Sections.OTP);
		onOpenWithcloseOnOverlayClick();
		// Intencional: executa apenas na montagem para verificar estado após reload
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};

